import React, { useEffect, useState } from 'react';
import {
	TextLabel,
	TextValue,
	Title,
	Icon,
	Form,
	CircleButton,
	Select,
} from '@fnacdarty/back-office-ui';
import PropTypes from 'prop-types';
import {
	NotificationContainer,
	NotificationManager,
} from 'react-notifications';
import { useTheme } from 'styled-components';
import { Modal } from '../../../../layouts';
import { addActivityComment } from '../../utils/activity';

import {
	StyledContainerActivityInfo,
	StyledLeftPanel,
	StyledRow,
	StyledRowPrimary,
	StyledHeader,
	StyledHeaderTitle,
	StyledContainer,
	StyledBlock,
	StyledTextAreaComment,
	StyledTextArea,
	StyledFieldsetContainer,
	StyledCommentContainer,
	StyledBlockModal,
} from './index.styled';
import { formatDateFR } from '../../../../utils/date';

const ActivityInfo = ({
	activity,
	setSelectedActivity,
	newComment,
	setNewComment,
	updateActivity,
}) => {
	const {
		project,
		customer,
		nuint = '',
		activityType = '',
		date = new Date(),
		duration = '',
		durationType = '',
		resource = '',
		comment = '',
	} = activity;
	const [displayedComment, setDisplayedComment] = useState(null);
	const [previousActivity, setPreviousActivity] = useState(null);
	const [showModalAddComment, setShowModalAddComment] = useState(false);
	const [titleButtonCancel] = useState('Annuler');
	const [titleButtonConfirm] = useState('Confirmer');
	const [formData, setFormData] = useState({
		commentary: '',
	});
	const handleOnChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
	};
	const theme = useTheme();
	const {
		civility,
		name,
		address,
		city = '',
		zipCode = '',
		mobilePhone = '',
		homePhone = '',
		floor = '',
		addressComplement = '',
		addressComplementBuilding = '',
		addressComplementStaircase = '',
		addressComplementCode = '',
		addressComplementDoor = '',
		habitationType = '',
	} = customer;

	const fullName = `${civility} ${name}`;
	const cityAdress = `${zipCode} ${city}`;
	const plannedDate = formatDateFR(new Date(date));
	const formatedDuration =
		duration && durationType ? `${duration} ${durationType}` : null;

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedValue, setSelectedValue] = useState({
		value: '',
		label: '',
	});
	const [phoneNumbers, setPhoneNumbers] = useState();

	const isVersionPC = () =>
		window.innerWidth >= `${process.env.REACT_APP_PC_VERSION}`;

	useEffect(() => {
		if (previousActivity === null) {
			setPreviousActivity(activity.id);
		} else if (previousActivity === activity.id) {
			if (newComment) {
				setDisplayedComment(newComment);
			} else {
				setDisplayedComment(comment);
			}
		} else {
			setNewComment(null);
			setPreviousActivity(activity.id);
			setDisplayedComment(comment);
		}
	}, [activity, comment, newComment, previousActivity, setNewComment]);

	// eslint-disable-next-line consistent-return
	const handleFormSubmit = async (value) => {
		if (value) {
			const commentData = {
				// eslint-disable-next-line react/prop-types
				nuint,
				comment: formData.commentary,
				sendComment: true,
			};

			const res = await addActivityComment(commentData);
			if (res.comment === commentData.comment) {
				NotificationManager.success(
					'Le commentaire a bien été ajouté',
					'',
				);

				const updatedActivity = {
					...activity,
					comment: res.comment,
				};
				setSelectedActivity(updatedActivity);
				updateActivity(updatedActivity);
				setNewComment(res.comment);
				setDisplayedComment(res.comment);
				setFormData({ commentary: '' });
			} else {
				NotificationManager.error(
					"Une erreur s'est produite lors de l'ajout du commentaire",
					'',
				);
			}
			setShowModalAddComment(false);
		} else {
			setShowModalAddComment(false);
		}
	};
	const validateCommentary = (value) => {
		handleFormSubmit(value);
	};

	const openCommentModal = () => {
		setShowModalAddComment(true);
		setFormData({ commentary: displayedComment });
	};

	let widthModal = '50%';
	if (!isVersionPC()) {
		widthModal = '95%';
	}

	const handleOpenModalCall = async () => {
		const telArray = [];
		setPhoneNumbers([]);
		if (mobilePhone) {
			telArray.push({
				label: mobilePhone,
				value: mobilePhone,
				isPrimary: true,
			});
		}
		if (homePhone) {
			telArray.push({
				label: homePhone,
				value: homePhone,
			});
		}
		setPhoneNumbers(telArray);

		if (telArray.length > 0) {
			const primaryNumber = telArray.find((number) => number.isPrimary);

			setSelectedValue(primaryNumber);
		}
		setIsModalOpen(true);
	};

	const handleCall = async (response) => {
		if (response && phoneNumbers.length > 0) {
			if (selectedValue?.value !== '') {
				document.location.href = `tel:${selectedValue.value}`;
				setIsModalOpen(false);
			}
			return;
		}
		setIsModalOpen(false);
	};

	return (
		<StyledContainerActivityInfo>
			<NotificationContainer />
			<StyledRowPrimary>
				{isVersionPC() && <Title level={3}>{fullName}</Title>}
				{!isVersionPC() && <Title level={4}>{fullName}</Title>}
			</StyledRowPrimary>
			<StyledRow>
				{isVersionPC() && <Title level={4}>{address}</Title>}
				{!isVersionPC() && <Title level={5}>{address}</Title>}
			</StyledRow>
			<StyledRow>
				{isVersionPC() && <Title level={4}>{cityAdress}</Title>}
				{!isVersionPC() && <Title level={5}>{cityAdress}</Title>}
			</StyledRow>

			<StyledLeftPanel>
				<StyledHeader>
					<StyledHeaderTitle>Projet</StyledHeaderTitle>
					<hr />
				</StyledHeader>
				{project && (
					<StyledRow>
						<TextLabel>Chantier :</TextLabel>
						<TextValue>{project}</TextValue>
					</StyledRow>
				)}
				{nuint && (
					<StyledRow>
						<TextLabel>Identifiant :</TextLabel>
						<TextValue>{nuint}</TextValue>
					</StyledRow>
				)}
				{activityType && (
					<StyledRow>
						<TextLabel>Type d&apos;activité :</TextLabel>
						<TextValue>{activityType}</TextValue>
					</StyledRow>
				)}
				{plannedDate && (
					<StyledRow>
						<TextLabel>Planifié le :</TextLabel>
						<TextValue>{plannedDate}</TextValue>
					</StyledRow>
				)}
				{duration && (
					<StyledRow>
						<TextLabel>Durée :</TextLabel>
						<TextValue>{formatedDuration}</TextValue>
					</StyledRow>
				)}
				{resource?.name && (
					<StyledRow>
						<TextLabel>Intervenant :</TextLabel>
						<TextValue>{resource.name}</TextValue>
					</StyledRow>
				)}
				<StyledHeader>
					<StyledHeaderTitle>Informations client</StyledHeaderTitle>
					<hr />
				</StyledHeader>

				<StyledRow>
					<TextLabel>Type d&apos;habitation :</TextLabel>
					<TextValue>{habitationType}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Bâtiment :</TextLabel>
					<TextValue>{addressComplementBuilding}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Porte :</TextLabel>
					<TextValue>{addressComplementDoor}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Escalier :</TextLabel>
					<TextValue>{addressComplementStaircase}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Etage : </TextLabel>
					<TextValue>{floor}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Code :</TextLabel>
					<TextValue>{addressComplementCode}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Complément :</TextLabel>
					<TextValue>{addressComplement}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Tél Mobile :</TextLabel>
					<TextValue>{mobilePhone}</TextValue>
				</StyledRow>

				<StyledRow>
					<TextLabel>Tél Domicile :</TextLabel>
					<TextValue>{homePhone}</TextValue>
					{!isVersionPC() && (
						<CircleButton
							size={50}
							color={theme.colors.primary}
							className={'CircleButtonPhone'}
							onClick={handleOpenModalCall}
						>
							<Icon name="phone" width={28} color="white" />
						</CircleButton>
					)}
					{isModalOpen && (
						<Modal
							title={'Appel du client'}
							onClickCallback={handleCall}
							confirmAction={
								phoneNumbers.length > 0 ? 'Appeler' : 'Ok'
							}
							cancelAction={
								phoneNumbers.length > 0 ? 'Annuler' : ''
							}
						>
							<StyledBlockModal>
								{phoneNumbers.length > 0 ? (
									<Select
										options={phoneNumbers}
										selectedValue={selectedValue}
										setSelectedValue={setSelectedValue}
									/>
								) : (
									<span>
										Aucun numéro de téléphone renseigné.
									</span>
								)}
							</StyledBlockModal>
						</Modal>
					)}
				</StyledRow>
				<hr />
				<StyledFieldsetContainer>
					<StyledCommentContainer
						onClick={() => {
							openCommentModal();
						}}
					>
						{isVersionPC() && <Title level={3}>Commentaire</Title>}
						{!isVersionPC() && <Title level={4}>Commentaire</Title>}

						<CircleButton
							size={30}
							color={theme.colors.primary}
							style={{
								position: 'absolute',
								top: '-5%',
								right: 0,
							}}
							onClick={() => {
								openCommentModal();
							}}
						>
							<Icon
								name="pencil-square"
								width={20}
								height={20}
								color={theme.colors.background}
							/>
						</CircleButton>
					</StyledCommentContainer>

					{showModalAddComment && (
						<Modal
							title="Ajouter un commentaire"
							onClickCallback={validateCommentary}
							confirmAction={titleButtonConfirm}
							cancelAction={titleButtonCancel}
							style={{
								position: 'fixed',
								width: widthModal,
							}}
						>
							<StyledContainer>
								{nuint !== null && (
									<Form onSubmit={handleFormSubmit}>
										<StyledBlock>
											<StyledTextArea
												name="commentary"
												type="text"
												placeholder=""
												required
												label="commentary"
												value={formData.commentary}
												onChange={handleOnChange}
											/>
										</StyledBlock>
									</Form>
								)}
							</StyledContainer>
						</Modal>
					)}
					{/* eslint-disable-next-line no-nested-ternary */}
					{displayedComment && displayedComment.trim() !== '' ? (
						<StyledRow>
							<StyledTextAreaComment
								onClick={() => {
									openCommentModal();
								}}
							>
								{displayedComment}
							</StyledTextAreaComment>
						</StyledRow>
					) : (
						<StyledRow>
							<TextValue>Aucun</TextValue>
						</StyledRow>
					)}
				</StyledFieldsetContainer>
			</StyledLeftPanel>
		</StyledContainerActivityInfo>
	);
};

ActivityInfo.propTypes = {
	activity: PropTypes.object.isRequired,
	setSelectedActivity: PropTypes.func,
	newComment: PropTypes.string,
	setNewComment: PropTypes.func.isRequired,
	updateActivity: PropTypes.func.isRequired,
};

export default ActivityInfo;
